import styled from 'styled-components'
import {
  PiHandshakeLight,
  PiHandshakeFill,
  PiMagnifyingGlass,
  PiMagnifyingGlassFill,
  PiIdentificationCard,
  PiIdentificationCardFill,
  PiHouse,
  PiHouseFill,
  PiPlusCircle,
  PiPlusCircleFill,
} from 'react-icons/pi'
import { Link, useLocation } from 'react-router-dom'
import { MobileNavItem } from '../Navbar/MobileSlideOutMenu'
import { useIsActive } from 'hooks/useIsActive'
import { cn } from 'components/UI/cn'
import mobileLogo from 'assets/Name - White Transparent.svg'

import * as S from './Footer.styles'
import { useCallback, useState } from 'react'
import MobileDrawer from 'components/MobileDrawer'

const SUPPORT_EMAIL = 'support@firstbite.io'

const handleEmailClick = () => {
  window.open(`mailto:${SUPPORT_EMAIL}`)
}

const items = [
  {
    label: 'Help',
    to: 'https://help.firstbite.io/',
  },
  {
    label: 'Privacy',
    to: '/privacy-policy',
  },
  {
    label: 'Terms',
    to: '/terms-of-use',
  },
  {
    label: 'Contact',
    to: '#',
    onClick: handleEmailClick,
  },
]

export const MobileUnauthenticatedFooter = () => {
  const getIsActive = useIsActive()

  return (
    <div className="w-full px-[20px] bg-brand-hover flex justify-between">
      {items.map(({ label, to, onClick }, i) => (
        <Link
          key={i}
          to={to}
          replace={false}
          onClick={onClick}
          className={cn(
            'flex items-center justify-center text-sm text-white no-underline transition-all duration-75 ease-in-out h-[40px]',
            'hover:bg-nav-bg-hover hover:no-underline hover:text-nav-text-muted',
            getIsActive(to) ? 'font-medium' : 'font-light'
          )}
        >
          {label}
        </Link>
      ))}
      <img
        src={mobileLogo}
        alt="First Bite"
        className="h-auto w-[81px] aspect-[27/8]"
      />
    </div>
  )
}

const MobileFooterItem = styled(Link)<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  font-weight: 300;
  position: relative;
  color: ${({ $isActive }) => ($isActive ? '#191D23' : '#6E6E6E')};
  text-decoration: none;
  transition: color 0.2s ease;
`

const SearchIconWrapper = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $isActive }) => ($isActive ? '#191D23' : '#6E6E6E')};
`

const Span = styled.span`
  font-size: 12px;
`

const menuItems = [
  { icon: PiHouse, activeIcon: PiHouseFill, label: 'Home', to: '/' },
  {
    icon: PiHandshakeLight,
    activeIcon: PiHandshakeFill,
    label: 'Deals',
    to: '/deals',
  },
  {
    icon: PiIdentificationCard,
    activeIcon: PiIdentificationCardFill,
    label: 'Contacts',
    to: '/contacts',
  },
]

export function MobileFooter() {
  const getIsActive = useIsActive()
  const location = useLocation()
  const [isFooterOpen, setIsFooterOpen] = useState(false)

  // Check if on search page
  const isSearchActive = location.pathname === '/search'
  const isCreateActive = location.pathname.includes('create')

  const handleCreateClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()
      setIsFooterOpen(true)
    },
    []
  )

  return (
    <S.MobileWrapper>
      <S.MobileContent>
        {/* nav items  */}
        {menuItems.map((item: MobileNavItem) => {
          // Don't show as active if search modal is open
          const isItemActive =
            !isSearchActive && !isCreateActive && getIsActive(item.to)
          return (
            <MobileFooterItem
              $isActive={isItemActive}
              to={item.to}
              key={item.label}
            >
              {isItemActive ? <item.activeIcon /> : <item.icon />}
              <Span>{item.label}</Span>
            </MobileFooterItem>
          )
        })}

        {/* popup actions  */}
        <MobileFooterItem to="/search" $isActive={isSearchActive}>
          <SearchIconWrapper $isActive={isSearchActive}>
            {isSearchActive ? <PiMagnifyingGlassFill /> : <PiMagnifyingGlass />}
          </SearchIconWrapper>
          <Span>Search</Span>
        </MobileFooterItem>
        <MobileFooterItem
          $isActive={isCreateActive}
          onClick={handleCreateClick}
          to="#"
        >
          {isCreateActive ? <PiPlusCircleFill /> : <PiPlusCircle />}
          <Span>Create</Span>
        </MobileFooterItem>

        {isFooterOpen && (
          <MobileDrawer
            isOpen={isFooterOpen}
            onClose={() => setIsFooterOpen(false)}
          />
        )}
      </S.MobileContent>
    </S.MobileWrapper>
  )
}
